// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"Z8-z"};